'use strict';

exports.__esModule = true;
exports['default'] = thunkMiddleware;
function thunkMiddleware(_ref) {
  var dispatch = _ref.dispatch;
  var getState = _ref.getState;

  return function (next) {
    return function (action) {
      if (typeof action === 'function') {
        return action(dispatch, getState);
      }

      return next(action);
    };
  };
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/redux-thunk/lib/index.js
 ** module id = 686
 ** module chunks = 0
 **/